import CommonService from './common.service'
import { _object } from 'utils/interfaces'

class CategoryService extends CommonService {
  async getCategories(params: _object) {
    return await this.get(`/categories/?${params}`)
  }

  async UpdateCategory(id: string | undefined, params: { [key: string]: boolean }) {
    return await this.put(`/categories/${id}`, params)
  }
}

export const categoryService = new CategoryService()
